// @flow

import { useMutation } from 'react-query';
import type { UseMutationOptions } from 'react-query';
import GrossRentsService from '../../../services/grossRentsService';
import useAbortController from '../../../hooks/useAbortController';

const grossRentsService = new GrossRentsService();

type DeleteGrossRentChangeVariables = {
  effectiveDate: string,
};

const useDeleteGrossRentChangeMutation = ({
  propertyId,
  organizationId,
  options,
}: {
  propertyId: string,
  organizationId: string,
  options?: UseMutationOptions<
    Object,
    mixed,
    DeleteGrossRentChangeVariables,
    mixed,
  >,
}) => {
  const abortControllerOptions = useAbortController();

  return useMutation(
    async ({ effectiveDate }: DeleteGrossRentChangeVariables) => {
      return grossRentsService.deleteGrossRentChange(
        organizationId,
        propertyId,
        effectiveDate,
        abortControllerOptions,
      );
    },
    options,
  );
};

export default useDeleteGrossRentChangeMutation;
